import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/question/:id',
    name: 'question-detail',
    // 路由懒加载
    component: () => import('../views/QuestionDetailView.vue')
  },
  {
    path: '/timeline',
    name: 'history-timeline',
    // 路由懒加载
    component: () => import('../views/TimelineView.vue')
  }
]

const router = new VueRouter({
  mode: 'history', // 使用history模式，没有#号
  base: process.env.BASE_URL,
  routes
})

export default router 